import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEntity } from '@uswitch/ev-utils/context/selectors';
import { Container } from '@uswitch/ev-core/react';
import HeroSecondary from '../../elements/hero-secondary';
import { cf2imgix } from '../../elements/imgix-img';
import Breadcrumb from '../../compounds/breadcrumb';
import Grid from '../../compounds/grid/grid-from-json.connected';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var ConnectedHeroSecondary = function ConnectedHeroSecondary(props) {
  var _image$file;

  var image = useEntity(props.image);

  var breadcrumbs = _jsx(Breadcrumb, {
    entity: props.breadcrumbs
  });

  return _jsx(HeroSecondary, {
    breadcrumbs: props.breadcrumbs && breadcrumbs,
    container: Container,
    image: cf2imgix(image === null || image === void 0 ? void 0 : (_image$file = image.file) === null || _image$file === void 0 ? void 0 : _image$file.url),
    imageOnMobile: props.displayImageOnMobile,
    imageOnTablet: props.displayImageOnTablet,
    children: _jsx(Grid, _objectSpread({}, props))
  });
};

export default ConnectedHeroSecondary;
//# sourceMappingURL=hero-secondary.connected.js.map